var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 165,
    viewBox: "0 0 166 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.900391,
    y: 0.0146484,
    width: 164.88,
    height: 164.883,
    rx: 82.44,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_636_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 83,
    transform: "translate(41.8441 40.9563)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.348 123.956C79.0998 123.956 41.8441 123.586 41.8441 110.804C41.8441 101.566 58.7257 99.0257 70.3089 98.2137L75.0663 105.039C60.2293 106.084 51.1361 109.228 49.2904 110.82C51.876 113.151 64.1911 116.729 83.3321 116.729C102.473 116.729 114.804 113.143 117.382 110.82C115.457 109.139 106.411 106.02 90.3807 105.112L95.52 98.1494C106.507 99.0579 124.828 101.92 124.828 110.812C124.828 123.594 87.5724 123.964 83.3242 123.964L83.348 123.956Z",
    fill: "#D88284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.348 40.9563C71.0727 40.9563 61.1203 51.0137 61.1203 63.4187C61.1203 83.8873 83.348 105.932 83.348 105.932C83.348 105.932 105.576 81.3951 105.576 63.4187C105.576 51.0137 95.6234 40.9563 83.348 40.9563ZM83.348 74.4972C76.9041 74.4972 71.6852 69.2232 71.6852 62.7112C71.6852 56.1992 76.9041 50.9253 83.348 50.9253C89.792 50.9253 95.0108 56.1992 95.0108 62.7112C95.0108 69.2232 89.792 74.4972 83.348 74.4972Z",
    fill: "#D88284"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_636_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 83,
    fill: "white",
    transform: "translate(41.8441 40.9563)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.0a3da905438ed213d2eba9943024f843.svg";
export { ForwardRef as ReactComponent };